import React, { useEffect } from 'react';
import {
  Group,
  Rect,
  Text as SlideText,
  Image as KonvaImage
} from 'react-konva';
import useImage from 'use-image';
import { Slide as ISlide, Text, Image } from 'providers/SlideEditorProvider';
import SlideImage from './SlideImage';

interface IProps {
  slide: ISlide;
  x: number;
}

const Slide = (props: IProps) => {
  const {
    background,
    images,
    texts,
    backgroundPosition = { x: 0, y: 0 },
    backgroundScale = 1
  } = props.slide;
  const [image] = useImage(background);
  const [nupitch] = useImage(
    'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/IMG_1722.jpg'
  );
  const [nodes, setNodes] = React.useState<(Image | Text)[]>([]);

  useEffect(() => {
    const sortedNodes = [...texts, ...images].sort(
      (a, b) => a.zIndex - b.zIndex
    );

    setNodes(sortedNodes);
  }, [texts, images]);

  return (
    <Group
      x={props.x}
      width={600}
      clipFunc={ctx => {
        ctx.rect(0, 0, 600, window.innerHeight);
      }}
    >
      <Rect width={600} height={window.innerHeight} fill="black" />
      <Rect
        height={window.innerHeight}
        fillPatternImage={image}
        x={backgroundPosition.x}
        y={backgroundPosition.y}
        fillPatternRepeat="no-repeat"
        width={window.innerWidth}
        fillPatternScale={{
          x: backgroundScale,
          y: backgroundScale
        }}
      />

      {nodes.map((node, index) =>
        'text' in node ? (
          <SlideText
            key={index}
            x={node.x}
            y={node.y}
            text={node.text}
            fill={node.color}
            fontStyle={node.fontStyle}
            fontSize={node.size}
            rotation={node.roration}
            width={node.width}
            align={node.alignment}
          />
        ) : (
          <SlideImage
            key={index}
            url={node.url}
            x={node.x}
            y={node.y}
            width={node.width}
            height={node.height}
            rotation={node.roration}
          />
        )
      )}
      <KonvaImage
        image={nupitch}
        x={window.innerWidth > 600 ? 390 : window.innerWidth - 210}
        y={window.innerHeight - 100}
        width={180}
        height={40}
        opacity={0.6}
      />
    </Group>
  );
};

export default Slide;
